import * as D from "react";
import oe from "react";
import W from "classnames";
import { Tooltip as Ii, tableFilters as J, DefaultCell as Y, Table as qe, TablePaginator as Fi, Badge as Li, Text as S, Surface as Me, LabeledSelect as Pi, InformationPanel as Ti, InformationPanelHeader as Ni, InformationPanelBody as Gi, Label as _, InformationPanelWrapper as _i, Button as ki, ThemeProvider as Bi } from "@itwin/itwinui-react";
import ji from "@tippyjs/react";
var A = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Ke(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var ue = { exports: {} }, ee = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ee, Je;
function Ze() {
  if (Je)
    return Ee;
  Je = 1;
  var n = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, C = Object.prototype.propertyIsEnumerable;
  function g(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function u() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var R = Object.getOwnPropertyNames(s).map(function(w) {
        return s[w];
      });
      if (R.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(w) {
        p[w] = w;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch (w) {
      return !1;
    }
  }
  return Ee = u() ? Object.assign : function(o, s) {
    for (var a, R = g(o), p, w = 1; w < arguments.length; w++) {
      a = Object(arguments[w]);
      for (var I in a)
        i.call(a, I) && (R[I] = a[I]);
      if (n) {
        p = n(a);
        for (var F = 0; F < p.length; F++)
          C.call(a, p[F]) && (R[p[F]] = a[p[F]]);
      }
    }
    return R;
  }, Ee;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xe;
function Oi() {
  if (Xe)
    return ee;
  Xe = 1, Ze();
  var n = oe, i = 60103;
  if (ee.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var C = Symbol.for;
    i = C("react.element"), ee.Fragment = C("react.fragment");
  }
  var g = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, R, p) {
    var w, I = {}, F = null, N = null;
    p !== void 0 && (F = "" + p), R.key !== void 0 && (F = "" + R.key), R.ref !== void 0 && (N = R.ref);
    for (w in R)
      u.call(R, w) && !o.hasOwnProperty(w) && (I[w] = R[w]);
    if (a && a.defaultProps)
      for (w in R = a.defaultProps, R)
        I[w] === void 0 && (I[w] = R[w]);
    return { $$typeof: i, type: a, key: F, ref: N, props: I, _owner: g.current };
  }
  return ee.jsx = s, ee.jsxs = s, ee;
}
var be = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ye;
function Ai() {
  return Ye || (Ye = 1, function(n) {
    process.env.NODE_ENV !== "production" && function() {
      var i = oe, C = Ze(), g = 60103, u = 60106;
      n.Fragment = 60107;
      var o = 60108, s = 60114, a = 60109, R = 60110, p = 60112, w = 60113, I = 60120, F = 60115, N = 60116, y = 60121, v = 60122, c = 60117, f = 60129, E = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        g = h("react.element"), u = h("react.portal"), n.Fragment = h("react.fragment"), o = h("react.strict_mode"), s = h("react.profiler"), a = h("react.provider"), R = h("react.context"), p = h("react.forward_ref"), w = h("react.suspense"), I = h("react.suspense_list"), F = h("react.memo"), N = h("react.lazy"), y = h("react.block"), v = h("react.server.block"), c = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), f = h("react.debug_trace_mode"), h("react.offscreen"), E = h("react.legacy_hidden");
      }
      var x = typeof Symbol == "function" && Symbol.iterator, k = "@@iterator";
      function U(e) {
        if (e === null || typeof e != "object")
          return null;
        var r = x && e[x] || e[k];
        return typeof r == "function" ? r : null;
      }
      var V = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function B(e) {
        {
          for (var r = arguments.length, l = new Array(r > 1 ? r - 1 : 0), d = 1; d < r; d++)
            l[d - 1] = arguments[d];
          re("error", e, l);
        }
      }
      function re(e, r, l) {
        {
          var d = V.ReactDebugCurrentFrame, L = d.getStackAddendum();
          L !== "" && (r += "%s", l = l.concat([L]));
          var P = l.map(function(M) {
            return "" + M;
          });
          P.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, P);
        }
      }
      var ae = !1;
      function ne(e) {
        return !!(typeof e == "string" || typeof e == "function" || e === n.Fragment || e === s || e === f || e === o || e === w || e === I || e === E || ae || typeof e == "object" && e !== null && (e.$$typeof === N || e.$$typeof === F || e.$$typeof === a || e.$$typeof === R || e.$$typeof === p || e.$$typeof === c || e.$$typeof === y || e[0] === v));
      }
      function Q(e, r, l) {
        var d = r.displayName || r.name || "";
        return e.displayName || (d !== "" ? l + "(" + d + ")" : l);
      }
      function q(e) {
        return e.displayName || "Context";
      }
      function O(e) {
        if (e == null)
          return null;
        if (typeof e.tag == "number" && B("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
          return e.displayName || e.name || null;
        if (typeof e == "string")
          return e;
        switch (e) {
          case n.Fragment:
            return "Fragment";
          case u:
            return "Portal";
          case s:
            return "Profiler";
          case o:
            return "StrictMode";
          case w:
            return "Suspense";
          case I:
            return "SuspenseList";
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case R:
              var r = e;
              return q(r) + ".Consumer";
            case a:
              var l = e;
              return q(l._context) + ".Provider";
            case p:
              return Q(e, e.render, "ForwardRef");
            case F:
              return O(e.type);
            case y:
              return O(e._render);
            case N: {
              var d = e, L = d._payload, P = d._init;
              try {
                return O(P(L));
              } catch (M) {
                return null;
              }
            }
          }
        return null;
      }
      var te = 0, Se, Ie, Fe, Le, Pe, Te, Ne;
      function Ge() {
      }
      Ge.__reactDisabledLog = !0;
      function ri() {
        {
          if (te === 0) {
            Se = console.log, Ie = console.info, Fe = console.warn, Le = console.error, Pe = console.group, Te = console.groupCollapsed, Ne = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: Ge,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          te++;
        }
      }
      function ai() {
        {
          if (te--, te === 0) {
            var e = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: C({}, e, {
                value: Se
              }),
              info: C({}, e, {
                value: Ie
              }),
              warn: C({}, e, {
                value: Fe
              }),
              error: C({}, e, {
                value: Le
              }),
              group: C({}, e, {
                value: Pe
              }),
              groupCollapsed: C({}, e, {
                value: Te
              }),
              groupEnd: C({}, e, {
                value: Ne
              })
            });
          }
          te < 0 && B("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var ve = V.ReactCurrentDispatcher, De;
      function ge(e, r, l) {
        {
          if (De === void 0)
            try {
              throw Error();
            } catch (L) {
              var d = L.stack.trim().match(/\n( *(at )?)/);
              De = d && d[1] || "";
            }
          return `
` + De + e;
        }
      }
      var we = !1, le;
      {
        var gi = typeof WeakMap == "function" ? WeakMap : Map;
        le = new gi();
      }
      function _e(e, r) {
        if (!e || we)
          return "";
        {
          var l = le.get(e);
          if (l !== void 0)
            return l;
        }
        var d;
        we = !0;
        var L = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var P;
        P = ve.current, ve.current = null, ri();
        try {
          if (r) {
            var M = function() {
              throw Error();
            };
            if (Object.defineProperty(M.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(M, []);
              } catch (H) {
                d = H;
              }
              Reflect.construct(e, [], M);
            } else {
              try {
                M.call();
              } catch (H) {
                d = H;
              }
              e.call(M.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (H) {
              d = H;
            }
            e();
          }
        } catch (H) {
          if (H && d && typeof H.stack == "string") {
            for (var b = H.stack.split(`
`), j = d.stack.split(`
`), T = b.length - 1, G = j.length - 1; T >= 1 && G >= 0 && b[T] !== j[G]; )
              G--;
            for (; T >= 1 && G >= 0; T--, G--)
              if (b[T] !== j[G]) {
                if (T !== 1 || G !== 1)
                  do
                    if (T--, G--, G < 0 || b[T] !== j[G]) {
                      var z = `
` + b[T].replace(" at new ", " at ");
                      return typeof e == "function" && le.set(e, z), z;
                    }
                  while (T >= 1 && G >= 0);
                break;
              }
          }
        } finally {
          we = !1, ve.current = P, ai(), Error.prepareStackTrace = L;
        }
        var Z = e ? e.displayName || e.name : "", He = Z ? ge(Z) : "";
        return typeof e == "function" && le.set(e, He), He;
      }
      function ke(e, r, l) {
        return _e(e, !1);
      }
      function li(e) {
        var r = e.prototype;
        return !!(r && r.isReactComponent);
      }
      function Re(e, r, l) {
        if (e == null)
          return "";
        if (typeof e == "function")
          return _e(e, li(e));
        if (typeof e == "string")
          return ge(e);
        switch (e) {
          case w:
            return ge("Suspense");
          case I:
            return ge("SuspenseList");
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case p:
              return ke(e.render);
            case F:
              return Re(e.type, r, l);
            case y:
              return ke(e._render);
            case N: {
              var d = e, L = d._payload, P = d._init;
              try {
                return Re(P(L), r, l);
              } catch (M) {
              }
            }
          }
        return "";
      }
      var Be = {}, je = V.ReactDebugCurrentFrame;
      function Ce(e) {
        if (e) {
          var r = e._owner, l = Re(e.type, e._source, r ? r.type : null);
          je.setExtraStackFrame(l);
        } else
          je.setExtraStackFrame(null);
      }
      function Ri(e, r, l, d, L) {
        {
          var P = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var M in e)
            if (P(e, M)) {
              var b = void 0;
              try {
                if (typeof e[M] != "function") {
                  var j = Error((d || "React class") + ": " + l + " type `" + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[M] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw j.name = "Invariant Violation", j;
                }
                b = e[M](r, M, d, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (T) {
                b = T;
              }
              b && !(b instanceof Error) && (Ce(L), B("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", d || "React class", l, M, typeof b), Ce(null)), b instanceof Error && !(b.message in Be) && (Be[b.message] = !0, Ce(L), B("Failed %s type: %s", l, b.message), Ce(null));
            }
        }
      }
      var se = V.ReactCurrentOwner, pe = Object.prototype.hasOwnProperty, Ci = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Oe, Ae, he;
      he = {};
      function ci(e) {
        if (pe.call(e, "ref")) {
          var r = Object.getOwnPropertyDescriptor(e, "ref").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.ref !== void 0;
      }
      function ui(e) {
        if (pe.call(e, "key")) {
          var r = Object.getOwnPropertyDescriptor(e, "key").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.key !== void 0;
      }
      function vi(e, r) {
        if (typeof e.ref == "string" && se.current && r && se.current.stateNode !== r) {
          var l = O(se.current.type);
          he[l] || (B('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(se.current.type), e.ref), he[l] = !0);
        }
      }
      function Di(e, r) {
        {
          var l = function() {
            Oe || (Oe = !0, B("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          l.isReactWarning = !0, Object.defineProperty(e, "key", {
            get: l,
            configurable: !0
          });
        }
      }
      function wi(e, r) {
        {
          var l = function() {
            Ae || (Ae = !0, B("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          l.isReactWarning = !0, Object.defineProperty(e, "ref", {
            get: l,
            configurable: !0
          });
        }
      }
      var pi = function(e, r, l, d, L, P, M) {
        var b = {
          $$typeof: g,
          type: e,
          key: r,
          ref: l,
          props: M,
          _owner: P
        };
        return b._store = {}, Object.defineProperty(b._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(b, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: d
        }), Object.defineProperty(b, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: L
        }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
      };
      function hi(e, r, l, d, L) {
        {
          var P, M = {}, b = null, j = null;
          l !== void 0 && (b = "" + l), ui(r) && (b = "" + r.key), ci(r) && (j = r.ref, vi(r, L));
          for (P in r)
            pe.call(r, P) && !Ci.hasOwnProperty(P) && (M[P] = r[P]);
          if (e && e.defaultProps) {
            var T = e.defaultProps;
            for (P in T)
              M[P] === void 0 && (M[P] = T[P]);
          }
          if (b || j) {
            var G = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
            b && Di(M, G), j && wi(M, G);
          }
          return pi(e, b, j, L, d, se.current, M);
        }
      }
      var de = V.ReactCurrentOwner, xe = V.ReactDebugCurrentFrame;
      function K(e) {
        if (e) {
          var r = e._owner, l = Re(e.type, e._source, r ? r.type : null);
          xe.setExtraStackFrame(l);
        } else
          xe.setExtraStackFrame(null);
      }
      var fe;
      fe = !1;
      function me(e) {
        return typeof e == "object" && e !== null && e.$$typeof === g;
      }
      function Ue() {
        {
          if (de.current) {
            var e = O(de.current.type);
            if (e)
              return `

Check the render method of \`` + e + "`.";
          }
          return "";
        }
      }
      function di(e) {
        {
          if (e !== void 0) {
            var r = e.fileName.replace(/^.*[\\\/]/, ""), l = e.lineNumber;
            return `

Check your code at ` + r + ":" + l + ".";
          }
          return "";
        }
      }
      var We = {};
      function fi(e) {
        {
          var r = Ue();
          if (!r) {
            var l = typeof e == "string" ? e : e.displayName || e.name;
            l && (r = `

Check the top-level render call using <` + l + ">.");
          }
          return r;
        }
      }
      function Ve(e, r) {
        {
          if (!e._store || e._store.validated || e.key != null)
            return;
          e._store.validated = !0;
          var l = fi(r);
          if (We[l])
            return;
          We[l] = !0;
          var d = "";
          e && e._owner && e._owner !== de.current && (d = " It was passed a child from " + O(e._owner.type) + "."), K(e), B('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', l, d), K(null);
        }
      }
      function $e(e, r) {
        {
          if (typeof e != "object")
            return;
          if (Array.isArray(e))
            for (var l = 0; l < e.length; l++) {
              var d = e[l];
              me(d) && Ve(d, r);
            }
          else if (me(e))
            e._store && (e._store.validated = !0);
          else if (e) {
            var L = U(e);
            if (typeof L == "function" && L !== e.entries)
              for (var P = L.call(e), M; !(M = P.next()).done; )
                me(M.value) && Ve(M.value, r);
          }
        }
      }
      function mi(e) {
        {
          var r = e.type;
          if (r == null || typeof r == "string")
            return;
          var l;
          if (typeof r == "function")
            l = r.propTypes;
          else if (typeof r == "object" && (r.$$typeof === p || r.$$typeof === F))
            l = r.propTypes;
          else
            return;
          if (l) {
            var d = O(r);
            Ri(l, e.props, "prop", d, e);
          } else if (r.PropTypes !== void 0 && !fe) {
            fe = !0;
            var L = O(r);
            B("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", L || "Unknown");
          }
          typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && B("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Ei(e) {
        {
          for (var r = Object.keys(e.props), l = 0; l < r.length; l++) {
            var d = r[l];
            if (d !== "children" && d !== "key") {
              K(e), B("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", d), K(null);
              break;
            }
          }
          e.ref !== null && (K(e), B("Invalid attribute `ref` supplied to `React.Fragment`."), K(null));
        }
      }
      function ze(e, r, l, d, L, P) {
        {
          var M = ne(e);
          if (!M) {
            var b = "";
            (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var j = di(L);
            j ? b += j : b += Ue();
            var T;
            e === null ? T = "null" : Array.isArray(e) ? T = "array" : e !== void 0 && e.$$typeof === g ? (T = "<" + (O(e.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : T = typeof e, B("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", T, b);
          }
          var G = hi(e, r, l, L, P);
          if (G == null)
            return G;
          if (M) {
            var z = r.children;
            if (z !== void 0)
              if (d)
                if (Array.isArray(z)) {
                  for (var Z = 0; Z < z.length; Z++)
                    $e(z[Z], e);
                  Object.freeze && Object.freeze(z);
                } else
                  B("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                $e(z, e);
          }
          return e === n.Fragment ? Ei(G) : mi(G), G;
        }
      }
      function bi(e, r, l) {
        return ze(e, r, l, !0);
      }
      function Mi(e, r, l) {
        return ze(e, r, l, !1);
      }
      var yi = Mi, Si = bi;
      n.jsx = yi, n.jsxs = Si;
    }();
  }(be)), be;
}
(function(n) {
  process.env.NODE_ENV === "production" ? n.exports = Oi() : n.exports = Ai();
})(ue);
const t = ue.exports.jsx, m = ue.exports.jsxs, ye = ue.exports.Fragment, ei = ({
  children: n,
  className: i,
  ...C
}) => /* @__PURE__ */ t(Ii, {
  content: n,
  appendTo: () => document.body,
  children: /* @__PURE__ */ t("span", {
    className: W("isr-line-clamp", i),
    ...C,
    children: n
  })
});
const ie = (n) => {
  const {
    icon: i,
    children: C,
    selected: g,
    className: u,
    ...o
  } = n;
  return /* @__PURE__ */ m("div", {
    ...o,
    className: W("isr-banner-tile-item", {
      "isr-banner-tile-item-selected": g,
      "isr-banner-tile-item-on-click": !!o.onClick
    }, u),
    children: [i && /* @__PURE__ */ t("div", {
      className: "isr-banner-tile-icon",
      children: i
    }), /* @__PURE__ */ t("span", {
      className: "isr-banner-tile-body",
      children: C[0]
    }), /* @__PURE__ */ t("span", {
      className: "isr-banner-tile-footer",
      children: C[1]
    })]
  });
}, xi = (n) => D.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...n },
  D.createElement("path", { d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zM6.65 12L3 8.59l1.4-1.3 2.36 2.2L11.59 5 13 6.29z" })
), Ui = (n) => D.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...n },
  D.createElement("path", { d: "M9 12H7v-2h2v2zm0-3H7V4h2v5zm2.314-9H4.686L0 4.686v6.628L4.686 16h6.628L16 11.314V4.686L11.314 0z" })
), Wi = (n) => D.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...n },
  D.createElement("path", { d: "M15.868 13.267l-6.77-11.62a1.15 1.15 0 00-1.1-.67 1.17 1.17 0 00-1.1.69l-6.77 11.59a1.2 1.2 0 001.1 1.72h13.45a1.19 1.19 0 001.19-1.71zm-6.87-.29h-2v-2h2zm0-3h-2v-5h2z" })
), Vi = (n) => D.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...n },
  D.createElement("path", { d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zm1.2 3.2a.923.923 0 01.997.843l.003.057a1.31 1.31 0 01-1.3 1.2.945.945 0 01-1-1 1.228 1.228 0 011.3-1.1zm-2 9.6c-.5 0-.9-.3-.5-1.7l.6-2.4c.1-.4.1-.5 0-.5-.2-.1-.9.2-1.3.5l-.2-.5a6.497 6.497 0 013.3-1.6c.5 0 .6.6.3 1.6l-.7 2.6c-.1.5-.1.6.1.6a2.003 2.003 0 001.1-.6l.3.4a5.769 5.769 0 01-3 1.6z" })
);
const $i = {
  success: xi,
  error: Ui,
  warning: Wi,
  informational: Vi
}, X = ({
  status: n,
  className: i,
  ...C
}) => {
  const g = $i[n];
  return /* @__PURE__ */ t(g, {
    className: W("isr-status-icon", `isr-status-icon-${n}`, i),
    ...C
  });
};
const ii = (n) => D.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...n },
  D.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#a6afb7" }),
  D.createElement("path", { d: "M11 0l3 3h-3z", fill: "#747a80" })
), ce = (n) => D.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...n },
  D.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#548ec7" }),
  D.createElement("path", { d: "M10.747 12.35a6.255 6.255 0 01-1.35-3.402C7.856 11.32 6.7 11.526 6.025 10.392L5.253 14H4l2.024-8.866 1.06-.206c.097 0-.867 3.917.29 4.33S10.071 4 10.071 4l1.253.206c-.867 2.371-.964 4.742.675 6.907z", fill: "#fff" }),
  D.createElement("path", { d: "M11 0l3 3h-3z", fill: "#3d648a" })
), zi = {
  Fatal: "Fatal Error",
  Error: "Error",
  Critical: "Critical Warning",
  Warning: "Warning",
  Info: "Info",
  fileName: "File name",
  level: "Status",
  category: "Issue",
  type: "Type",
  message: "Message"
}, Hi = {
  dgn: /* @__PURE__ */ t(ce, {}),
  dgnlib: /* @__PURE__ */ t(ce, {})
}, ni = ({
  fileRecords: n,
  displayStrings: i,
  fileTypeIcons: C,
  sourceFilesInfo: g,
  className: u,
  ...o
}) => {
  const s = D.useContext($), a = s == null ? void 0 : s.workflowMapping, R = D.useMemo(() => ({
    ...Hi,
    ...C
  }), [C]), p = D.useMemo(() => (n || (s == null ? void 0 : s.reportData.filerecords) || []).flatMap(({
    file: f,
    auditrecords: E
  }) => (E != null ? E : []).flatMap(({
    auditinfo: h
  }) => a && (h == null ? void 0 : h.category) && h.type && Object.hasOwn(a, h.category) && Object.hasOwn(a[h.category], h.type) ? a[h.category][h.type].some((x) => s.focusedWorkflows.includes(x)) ? {
    fileId: f == null ? void 0 : f.identifier,
    impactedWorkflows: a[h.category][h.type],
    ...h
  } : [] : s != null && s.focusedWorkflows.includes("Unorganized") ? {
    fileId: f == null ? void 0 : f.identifier,
    ...h
  } : [])).filter((f) => {
    const E = f.level;
    let h = "Info";
    return E === "Error" || E === "Fatal" ? h = "Error" : (E === "Warning" || E === "Critical") && (h = "Warning"), s == null ? void 0 : s.focusedIssues.some((x) => h === x);
  }), [n, s == null ? void 0 : s.reportData.filerecords, s == null ? void 0 : s.focusedWorkflows, s == null ? void 0 : s.focusedIssues, a]), w = D.useMemo(() => ({
    ...zi,
    ...i
  }), [i]), I = D.useCallback((v) => {
    var f, E;
    const c = g || (s == null ? void 0 : s.reportData.sourceFilesInfo);
    return (c == null ? void 0 : c.fileId) === v ? c == null ? void 0 : c.fileName : (E = (f = c == null ? void 0 : c.Files) == null ? void 0 : f.find((h) => h.fileId === v)) == null ? void 0 : E.fileName;
  }, [g, s == null ? void 0 : s.reportData.sourceFilesInfo]), F = D.useCallback((v, c) => {
    const f = ["Fatal", "Error", "Critical", "Warning", "Info"], E = f.indexOf(v.original.level || ""), h = f.indexOf(c.original.level || "");
    return E > h ? 1 : -1;
  }, []), N = D.useMemo(() => [{
    id: "category",
    accessor: "category",
    Header: w.category,
    Filter: J.TextFilter(),
    minWidth: 75,
    maxWidth: 250,
    Cell: (v) => /* @__PURE__ */ t("div", {
      className: "iui-anchor",
      onClick: () => {
        var c;
        s == null || s.setCurrentAuditInfo({
          ...v.row.original,
          fileName: (c = v.row.original.fileName) != null ? c : I(v.row.original.fileId)
        });
      },
      children: v.value
    })
  }, {
    id: "type",
    accessor: "type",
    Header: w.type,
    Filter: J.TextFilter(),
    minWidth: 50,
    maxWidth: 250
  }, {
    id: "level",
    accessor: "level",
    Header: w.level,
    Filter: J.TextFilter(),
    minWidth: 75,
    maxWidth: 250,
    sortType: F,
    cellRenderer: ({
      cellElementProps: v,
      cellProps: c
    }) => {
      const f = c.row.original.level;
      return /* @__PURE__ */ t(Y, {
        cellElementProps: v,
        cellProps: c,
        startIcon: f === "Error" || f === "Fatal" || f === "Critical" ? /* @__PURE__ */ t(X, {
          status: "error"
        }) : f === "Warning" ? /* @__PURE__ */ t(X, {
          status: "warning"
        }) : f ? /* @__PURE__ */ t(X, {
          status: "informational"
        }) : void 0,
        children: f && f in w ? w[f] : f
      });
    }
  }, {
    id: "fileName",
    accessor: ({
      fileName: v,
      fileId: c
    }) => v != null ? v : I(c),
    Header: w.fileName,
    Filter: J.TextFilter(),
    cellClassName: "iui-main",
    minWidth: 150,
    cellRenderer: ({
      cellElementProps: v,
      cellProps: c
    }) => {
      var E;
      const f = (E = c.value) == null ? void 0 : E.substring(c.value.lastIndexOf(".") + 1);
      return /* @__PURE__ */ t(Y, {
        cellElementProps: v,
        cellProps: c,
        startIcon: f && f in R ? R[f] : /* @__PURE__ */ t(ii, {}),
        children: c.value
      });
    }
  }, {
    id: "message",
    accessor: "message",
    Header: w.message,
    Filter: J.TextFilter(),
    minWidth: 200,
    cellClassName: "isr-problems-message",
    Cell: ({
      value: v
    }) => /* @__PURE__ */ t(ei, {
      children: v
    })
  }], [s, w, R, I, F]), y = D.useCallback(({
    original: {
      level: v
    }
  }) => {
    switch (v) {
      case "Critical":
      case "Error":
      case "Fatal":
        return {
          status: "negative"
        };
      case "Warning":
        return {
          status: "warning"
        };
      default:
        return {};
    }
  }, []);
  return /* @__PURE__ */ t(qe, {
    enableVirtualization: !0,
    className: W("isr-problems-table", u),
    columns: N,
    data: p,
    emptyTableContent: "No data.",
    emptyFilteredTableContent: "No results found. Clear or try another filter.",
    isSortable: !0,
    initialState: {
      sortBy: [{
        id: "level"
      }]
    },
    rowProps: y,
    paginatorRenderer: (v) => /* @__PURE__ */ t(Fi, {
      pageSizeList: [10, 25, 50],
      ...v
    }),
    ...o
  });
}, Ji = (n) => D.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...n },
  D.createElement("path", { d: "M9 12H7v-2h2v2zm0-3H7V4h2v5zm2.314-9H4.686L0 4.686v6.628L4.686 16h6.628L16 11.314V4.686L11.314 0z", fill: "var(--iui-color-icon-negative, hsl(0 98% 60%))" })
);
const Xi = {
  failed: "Failed",
  processed: "Processed",
  processedWithIssues: "Processed with issues",
  fileName: "File name",
  status: "Status",
  path: "Path",
  fileID: "File ID",
  datasource: "Datasource",
  mainFile: "master"
}, Yi = {
  dgn: /* @__PURE__ */ t(ce, {}),
  dgnlib: /* @__PURE__ */ t(ce, {})
}, ti = ({
  displayStrings: n,
  sourceFilesInfo: i,
  fileRecords: C,
  fileTypeIcons: g,
  datasourceIcons: u,
  className: o,
  ...s
}) => {
  var y;
  const a = D.useMemo(() => ({
    ...Yi,
    ...g
  }), [g]), R = D.useMemo(() => ({
    ...Xi,
    ...n
  }), [n]), p = D.useContext($);
  C != null || (C = (y = p == null ? void 0 : p.reportData.filerecords) != null ? y : []);
  const w = D.useMemo(() => {
    const v = i || (p == null ? void 0 : p.reportData.sourceFilesInfo);
    return [{
      ...v,
      mainFile: !0
    }, ...v && v.Files ? v.Files.filter((c) => c.state !== "Hidden") : []];
  }, [i, p == null ? void 0 : p.reportData.sourceFilesInfo]), I = D.useMemo(() => {
    const v = w.filter((c) => !!c.fileId).map(({
      fileId: c
    }) => {
      const f = C == null ? void 0 : C.filter(({
        file: E
      }) => (E == null ? void 0 : E.identifier) === c).flatMap(({
        auditrecords: E
      }) => E != null ? E : []).some(({
        auditinfo: E
      }) => {
        var h;
        return ["Critical", "Fatal", "Warning", "Error"].includes((h = E == null ? void 0 : E.level) != null ? h : "");
      });
      return [c, f];
    });
    return Object.fromEntries(v);
  }, [w, C]), F = D.useMemo(() => [{
    id: "fileName",
    accessor: "fileName",
    minWidth: 125,
    Header: R.fileName,
    Filter: J.TextFilter(),
    cellRenderer: ({
      cellElementProps: v,
      cellProps: c
    }) => {
      var E;
      const f = (E = c.row.original.fileName) == null ? void 0 : E.substring(c.row.original.fileName.lastIndexOf(".") + 1);
      return /* @__PURE__ */ t(Y, {
        cellElementProps: v,
        cellProps: c,
        startIcon: f && f in a ? a[f] : /* @__PURE__ */ t(ii, {}),
        children: /* @__PURE__ */ m("div", {
          className: "isr-file-name",
          children: [c.row.original.fileName, c.row.original.mainFile && /* @__PURE__ */ t(Li, {
            backgroundColor: "primary",
            children: R.mainFile
          })]
        })
      });
    }
  }, {
    id: "status",
    Header: R.status,
    minWidth: 75,
    maxWidth: 200,
    cellRenderer: ({
      cellElementProps: v,
      cellProps: c
    }) => !c.row.original.fileExists && !c.row.original.bimFileExists ? /* @__PURE__ */ t(Y, {
      cellElementProps: v,
      cellProps: c,
      startIcon: /* @__PURE__ */ t(Ji, {}),
      children: /* @__PURE__ */ t(S, {
        children: R.failed
      })
    }) : c.row.original.fileId && I[c.row.original.fileId] ? /* @__PURE__ */ t(Y, {
      cellElementProps: v,
      cellProps: c,
      startIcon: /* @__PURE__ */ t(X, {
        status: "warning"
      }),
      children: /* @__PURE__ */ t(S, {
        children: R.processedWithIssues
      })
    }) : /* @__PURE__ */ t(Y, {
      cellElementProps: v,
      cellProps: c,
      startIcon: /* @__PURE__ */ t(X, {
        status: "success"
      }),
      children: /* @__PURE__ */ t(S, {
        children: R.processed
      })
    })
  }, {
    id: "path",
    accessor: "path",
    minWidth: 150,
    Header: R.path,
    Filter: J.TextFilter(),
    Cell: (v) => v.row.original.path && /* @__PURE__ */ t("a", {
      className: "iui-anchor",
      href: v.row.original.path,
      target: "_blank",
      rel: "noopener noreferrer",
      children: v.row.original.path
    })
  }, {
    id: "fileId",
    accessor: "fileId",
    minWidth: 100,
    Header: R.fileID,
    Filter: J.TextFilter(),
    Cell: (v) => /* @__PURE__ */ t(ei, {
      className: "isr-files-data-text",
      children: v.row.original.fileId
    })
  }, {
    id: "dataSource",
    accessor: "dataSource",
    minWidth: 100,
    Header: R.datasource,
    Filter: J.TextFilter(),
    cellRenderer: ({
      cellElementProps: v,
      cellProps: c
    }) => /* @__PURE__ */ t(Y, {
      cellElementProps: v,
      cellProps: c,
      startIcon: u && c.value in u ? u[c.value] : void 0,
      children: c.value
    })
  }], [R, a, I, u]), N = D.useCallback(({
    original: {
      fileExists: v,
      bimFileExists: c
    }
  }) => !v && !c ? {
    status: "negative"
  } : {}, []);
  return /* @__PURE__ */ t(ye, {
    children: /* @__PURE__ */ t(qe, {
      enableVirtualization: !0,
      className: W("isr-files-table", o),
      columns: F,
      data: w,
      emptyTableContent: "No data.",
      emptyFilteredTableContent: "No results found. Clear or try another filter.",
      isSortable: !0,
      rowProps: N,
      ...s
    })
  });
}, Qe = {
  synchronizationReport: "Synchronization Report",
  unknown: "unknown"
}, Qi = ({
  fileName: n,
  displayStrings: i,
  ...C
}) => {
  var o;
  const g = D.useContext($);
  if (!n) {
    if (!g)
      throw new Error("fileName must be specified or ReportTitle must be used inside Report");
    n = (o = g.reportData.sourceFilesInfo) == null ? void 0 : o.fileName;
  }
  const u = D.useMemo(() => ({
    ...Qe,
    ...i
  }), [i]);
  return /* @__PURE__ */ t(S, {
    variant: "title",
    ...C,
    children: `${n != null ? n : Qe.unknown} - ${u.synchronizationReport}`
  });
};
var si = {};
(function(n) {
  var i = A && A.__createBinding || (Object.create ? function(s, a, R, p) {
    p === void 0 && (p = R);
    var w = Object.getOwnPropertyDescriptor(a, R);
    (!w || ("get" in w ? !a.__esModule : w.writable || w.configurable)) && (w = { enumerable: !0, get: function() {
      return a[R];
    } }), Object.defineProperty(s, p, w);
  } : function(s, a, R, p) {
    p === void 0 && (p = R), s[p] = a[R];
  }), C = A && A.__setModuleDefault || (Object.create ? function(s, a) {
    Object.defineProperty(s, "default", { enumerable: !0, value: a });
  } : function(s, a) {
    s.default = a;
  }), g = A && A.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var a = {};
    if (s != null)
      for (var R in s)
        R !== "default" && Object.prototype.hasOwnProperty.call(s, R) && i(a, s, R);
    return C(a, s), a;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.SvgClock = void 0;
  const u = g(oe), o = (s) => u.createElement(
    "svg",
    { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...s },
    u.createElement("path", { d: "M8.6 9h-.2l-5-1.5a.486.486 0 01-.3-.6.42.42 0 01.6-.3L8 7.9V5.5a.5.5 0 011 0v3a.758.758 0 01-.2.4.35.35 0 01-.2.1M8 1.5A6.5 6.5 0 111.5 8 6.487 6.487 0 018 1.5M8 0a8 8 0 108 8 8.024 8.024 0 00-8-8z" })
  );
  n.SvgClock = o, n.default = n.SvgClock;
})(si);
const qi = /* @__PURE__ */ Ke(si);
var oi = {};
(function(n) {
  var i = A && A.__createBinding || (Object.create ? function(s, a, R, p) {
    p === void 0 && (p = R);
    var w = Object.getOwnPropertyDescriptor(a, R);
    (!w || ("get" in w ? !a.__esModule : w.writable || w.configurable)) && (w = { enumerable: !0, get: function() {
      return a[R];
    } }), Object.defineProperty(s, p, w);
  } : function(s, a, R, p) {
    p === void 0 && (p = R), s[p] = a[R];
  }), C = A && A.__setModuleDefault || (Object.create ? function(s, a) {
    Object.defineProperty(s, "default", { enumerable: !0, value: a });
  } : function(s, a) {
    s.default = a;
  }), g = A && A.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var a = {};
    if (s != null)
      for (var R in s)
        R !== "default" && Object.prototype.hasOwnProperty.call(s, R) && i(a, s, R);
    return C(a, s), a;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.SvgDocument = void 0;
  const u = g(oe), o = (s) => u.createElement(
    "svg",
    { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...s },
    u.createElement("path", { d: "M10 0H2v16h12V4h-4zm1 0v3h3z" })
  );
  n.SvgDocument = o, n.default = n.SvgDocument;
})(oi);
const Ki = /* @__PURE__ */ Ke(oi), Zi = {
  syncTime: "Sync Time",
  files: "Files Processed"
}, en = ({
  timestamp: n,
  filesCount: i,
  filesProcessed: C,
  displayStrings: g
}) => {
  var I, F, N, y;
  const u = D.useContext($);
  if (!n && !i) {
    if (!u)
      throw new Error("timestamp and numberOfFiles must be specified or ReportTimestamp and list of files must be used inside Report");
    n = new Date((F = (I = u.reportData.context) == null ? void 0 : I.timestamp) != null ? F : ""), i = (y = (N = u.reportData.sourceFilesInfo) == null ? void 0 : N.Files) == null ? void 0 : y.length;
  }
  const o = D.useMemo(() => ({
    ...Zi,
    ...g
  }), [g]), [s, a] = D.useState(""), [R, p] = D.useState("");
  D.useEffect(() => {
    var c, f;
    let v = {
      year: "numeric",
      month: "short",
      day: "numeric"
    };
    a((c = n == null ? void 0 : n.toLocaleDateString(void 0, v)) != null ? c : ""), v = {
      hour: "numeric",
      minute: "2-digit"
    }, p((f = n == null ? void 0 : n.toLocaleTimeString([], v)) != null ? f : "");
  }, [n]);
  const w = D.useMemo(() => {
    var v;
    return C ? [...C] : (v = u == null ? void 0 : u.reportData.sourceFilesInfo) != null && v.Files ? [u.reportData.sourceFilesInfo, ...u.reportData.sourceFilesInfo.Files] : [];
  }, [u == null ? void 0 : u.reportData.sourceFilesInfo, C]);
  return /* @__PURE__ */ m(Me, {
    elevation: 1,
    className: "isr-timestamp-container",
    children: [/* @__PURE__ */ m(ie, {
      icon: /* @__PURE__ */ t(qi, {}),
      children: [/* @__PURE__ */ m("span", {
        children: [/* @__PURE__ */ t(S, {
          children: s
        }), /* @__PURE__ */ t(S, {
          children: R
        })]
      }), /* @__PURE__ */ t(S, {
        variant: "small",
        children: o.syncTime
      })]
    }), /* @__PURE__ */ m(ie, {
      icon: /* @__PURE__ */ t(Ki, {}),
      children: [/* @__PURE__ */ t(S, {
        variant: "title",
        style: {
          fontWeight: "bold"
        },
        children: w.length
      }), /* @__PURE__ */ t(S, {
        variant: "small",
        children: o.files
      })]
    })]
  });
};
const nn = (n) => D.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...n },
  D.createElement("path", { d: "M5.472 15.978a.616.616 0 01-.756-.466L1.521 2.845a.66.66 0 01.437-.803.615.615 0 01.755.465l3.194 12.667a.662.662 0 01-.435.804zm7.159-8.09a6.694 6.694 0 01-1.834.183c-.602-.009-1.197-.05-1.8-.057a6.743 6.743 0 00-1.831.184 3.595 3.595 0 00-1.871 1.156l-.592-2.345-.516-2.043c-.175-.699-.365-1.446-.59-2.344a3.6 3.6 0 011.87-1.157 6.645 6.645 0 011.834-.18c.601.006 1.196.047 1.798.053a6.608 6.608 0 001.833-.181A3.606 3.606 0 0012.803 0l.592 2.343c.175.699.34 1.347.516 2.044l.589 2.346a3.616 3.616 0 01-1.87 1.156z", fillRule: "evenodd" })
), tn = {
  errors: "Errors",
  warnings: "Warnings",
  otherIssues: "Other issues",
  totalIssues: "Total Issues",
  unorganized: "Unorganized"
}, sn = (n) => {
  const i = D.useContext($), C = D.useMemo(() => ({
    ...tn,
    ...n.displayStrings
  }), [n.displayStrings]), g = D.useMemo(() => n.fileRecords || (i == null ? void 0 : i.reportData.filerecords) || [], [i == null ? void 0 : i.reportData.filerecords, n.fileRecords]), u = D.useMemo(() => {
    var y;
    return n.filesProcessed ? [...u] : (y = i == null ? void 0 : i.reportData.sourceFilesInfo) != null && y.Files ? [i.reportData.sourceFilesInfo, ...i.reportData.sourceFilesInfo.Files] : [];
  }, [i == null ? void 0 : i.reportData.sourceFilesInfo, n.filesProcessed]), [o, s] = D.useState(0), [a, R] = D.useState(0), [p, w] = D.useState(0), [I, F] = D.useState(0);
  D.useEffect(() => {
    let y = 0, v = 0, c = 0, f = [];
    i != null && i.workflowMapping && (f = Array.from(new Set(Object.values(i == null ? void 0 : i.workflowMapping).flatMap((h) => Object.values(h).flatMap((x) => x)))));
    const E = new Map(f.map((h) => [h, 0]));
    g == null || g.forEach((h) => {
      var x;
      (x = h.auditrecords) == null || x.forEach((k) => {
        var B, re, ae;
        const U = (B = k.auditinfo) == null ? void 0 : B.level;
        let V = "Info";
        if (U === "Error" || U === "Fatal" ? V = "Error" : (U === "Warning" || U === "Critical") && (V = "Warning"), (i == null ? void 0 : i.workflowMapping) && ((re = k.auditinfo) == null ? void 0 : re.category) && k.auditinfo.type && Object.hasOwn(i.workflowMapping, k.auditinfo.category) && Object.hasOwn(i.workflowMapping[k.auditinfo.category], k.auditinfo.type) && (i == null ? void 0 : i.focusedIssues.some((ne) => V === ne)) && i.workflowMapping[k.auditinfo.category][k.auditinfo.type].forEach((Q) => {
          const q = E.get(Q), O = q != null ? q : 0;
          E.set(Q, O + 1);
        }), (i == null ? void 0 : i.workflowMapping) && ((ae = k.auditinfo) == null ? void 0 : ae.category) && k.auditinfo.type && Object.hasOwn(i.workflowMapping, k.auditinfo.category) && Object.hasOwn(i.workflowMapping[k.auditinfo.category], k.auditinfo.type)) {
          if (!i.workflowMapping[k.auditinfo.category][k.auditinfo.type].some((Q) => i.focusedWorkflows.includes(Q)))
            return;
        } else if (!(i != null && i.focusedWorkflows.includes("Unorganized")))
          return;
        U === "Error" || U === "Fatal" ? y++ : U === "Warning" || U === "Critical" ? v++ : U === "Info" && c++;
      });
    }), s(y), R(v), w(c), F(y + v + c);
  }, [i == null ? void 0 : i.focusedIssues, i == null ? void 0 : i.focusedWorkflows, i == null ? void 0 : i.workflowMapping, g]);
  const N = D.useCallback((y) => i == null ? void 0 : i.setFocusedIssues((v) => v.some((c) => y === c) ? v.filter((c) => c !== y) : [...v, y]), [i]);
  return /* @__PURE__ */ m(Me, {
    elevation: 1,
    className: "isr-banner-container",
    children: [/* @__PURE__ */ m(ie, {
      icon: /* @__PURE__ */ t(nn, {}),
      children: [/* @__PURE__ */ t(S, {
        variant: "title",
        style: {
          fontWeight: "bold"
        },
        children: I
      }), /* @__PURE__ */ t(S, {
        variant: "small",
        children: C.totalIssues
      })]
    }), /* @__PURE__ */ m(ye, {
      children: [/* @__PURE__ */ m(ie, {
        onClick: () => N("Error"),
        selected: i == null ? void 0 : i.focusedIssues.some((y) => y === "Error"),
        icon: /* @__PURE__ */ t(X, {
          status: "error"
        }),
        children: [/* @__PURE__ */ t(S, {
          variant: "title",
          style: {
            fontWeight: "bold"
          },
          children: o
        }), /* @__PURE__ */ t(S, {
          variant: "small",
          children: C.errors
        })]
      }), /* @__PURE__ */ m(ie, {
        onClick: () => N("Warning"),
        selected: i == null ? void 0 : i.focusedIssues.some((y) => y === "Warning"),
        icon: /* @__PURE__ */ t(X, {
          status: "warning"
        }),
        children: [/* @__PURE__ */ t(S, {
          variant: "title",
          style: {
            fontWeight: "bold"
          },
          children: a
        }), /* @__PURE__ */ t(S, {
          variant: "small",
          children: C.warnings
        })]
      }), /* @__PURE__ */ m(ie, {
        onClick: () => N("Info"),
        selected: i == null ? void 0 : i.focusedIssues.some((y) => y === "Info"),
        icon: /* @__PURE__ */ t(X, {
          status: "informational"
        }),
        children: [/* @__PURE__ */ t(S, {
          variant: "title",
          style: {
            fontWeight: "bold"
          },
          children: p
        }), /* @__PURE__ */ t(S, {
          variant: "small",
          children: C.otherIssues
        })]
      })]
    })]
  });
}, on = {
  files: "Files",
  problems: "Problems"
}, rn = ({
  displayStrings: n,
  options: i,
  className: C,
  ...g
}) => {
  const u = D.useContext($);
  if (!u)
    throw new Error("ReportTableSelect must be used inside the Report component");
  const {
    currentTable: o,
    setCurrentTable: s
  } = u, a = {
    ...on,
    ...n
  };
  return /* @__PURE__ */ t(Pi, {
    label: "Show by",
    displayStyle: "inline",
    options: i != null ? i : [{
      value: "problems",
      label: a.problems
    }, {
      value: "files",
      label: a.files
    }],
    onChange: s,
    value: o,
    className: C,
    ...g
  });
};
const an = ({
  currentTable: n,
  children: i,
  className: C,
  ...g
}) => {
  var a, R;
  const u = D.useContext($);
  if (!n) {
    if (!u)
      throw new Error("currentTab must be specified or this component must be used inside Report");
    n = u.currentTable;
  }
  const o = (a = i == null ? void 0 : i[0]) != null ? a : /* @__PURE__ */ t(ti, {}), s = (R = i == null ? void 0 : i[1]) != null ? R : /* @__PURE__ */ t(ni, {});
  return /* @__PURE__ */ t("div", {
    className: W("isr-report-table-view", C),
    ...g,
    children: (() => {
      switch (n) {
        case "files":
          return o;
        case "problems":
          return s;
      }
    })()
  });
};
const gn = ({
  children: n,
  className: i,
  ...C
}) => /* @__PURE__ */ t("div", {
  className: W("isr-table-select-wrapper", i),
  ...C,
  children: n
});
const ln = {
  status: "Status",
  issueType: "Type",
  category: "Category",
  impactedWorkflows: "Impacted Workflows",
  fileName: "File Name",
  message: "Message",
  metadata: "Metadata"
}, Rn = ({
  displayStrings: n,
  className: i,
  ...C
}) => {
  var a, R, p;
  const g = oe.useContext($);
  if (!g)
    throw new Error("ReportInfoPanel must be used inside the Report component");
  const u = {
    ...ln,
    ...n
  }, {
    currentAuditInfo: o,
    setCurrentAuditInfo: s
  } = g;
  return /* @__PURE__ */ m(Ti, {
    className: i,
    isOpen: !!o,
    ...C,
    children: [/* @__PURE__ */ t(Ni, {
      onClose: () => s(void 0),
      children: /* @__PURE__ */ t(S, {
        variant: "subheading",
        children: (a = o == null ? void 0 : o.category) != null ? a : u.metadata
      })
    }), /* @__PURE__ */ m(Gi, {
      className: "isr-info-panel-body",
      children: [(o == null ? void 0 : o.category) && /* @__PURE__ */ m("span", {
        children: [/* @__PURE__ */ t(_, {
          as: "span",
          children: u.category
        }), o.category]
      }), (o == null ? void 0 : o.level) && /* @__PURE__ */ m("span", {
        children: [/* @__PURE__ */ t(_, {
          as: "span",
          children: u.status
        }), o.level]
      }), (o == null ? void 0 : o.type) && /* @__PURE__ */ m("span", {
        children: [/* @__PURE__ */ t(_, {
          as: "span",
          children: u.issueType
        }), (R = o == null ? void 0 : o.type) != null ? R : ""]
      }), (o == null ? void 0 : o.impactedWorkflows) && /* @__PURE__ */ m("span", {
        children: [/* @__PURE__ */ t(_, {
          as: "span",
          children: u.impactedWorkflows
        }), (p = o == null ? void 0 : o.impactedWorkflows) == null ? void 0 : p.map((w) => /* @__PURE__ */ t(S, {
          children: w
        }, w))]
      }), (o == null ? void 0 : o.fileName) && /* @__PURE__ */ m("span", {
        children: [/* @__PURE__ */ t(_, {
          as: "span",
          children: u.fileName
        }), o.fileName]
      }), (o == null ? void 0 : o.message) && /* @__PURE__ */ m("span", {
        children: [/* @__PURE__ */ t(_, {
          as: "span",
          children: u.message
        }), o == null ? void 0 : o.message]
      })]
    })]
  });
};
const Cn = ({
  className: n,
  children: i,
  ...C
}) => /* @__PURE__ */ t(_i, {
  className: W("isr-info-panel-wrapper", n),
  ...C,
  children: i
});
const cn = ({
  children: n,
  className: i,
  ...C
}) => /* @__PURE__ */ t("div", {
  className: W("isr-report-header-banner", i),
  ...C,
  children: n
});
const un = {
  activityid: "Activity Id",
  briefcaseid: "Briefcase Id",
  contextid: "Context Id",
  contextName: "Ctx. Name",
  jobDefID: "Job Def. Id",
  jobid: "Job Id",
  jobRunID: "Job Run Id",
  modelid: "Model Id",
  modelName: "Model Name",
  organizationName: "Org. Name",
  userEmail: "User Email",
  idsForTechSupport: "IDs for Tech Support"
}, vn = (n) => {
  var s;
  const {
    data: i
  } = n, C = D.useContext($), g = ((s = n.data) == null ? void 0 : s.reportData) || (C == null ? void 0 : C.reportData.context), u = D.useMemo(() => ({
    ...un,
    ...n.displayStrings
  }), [n.displayStrings]), o = {
    "Activity Id": (g == null ? void 0 : g.activityid) === "" ? "No Activity Id" : g == null ? void 0 : g.activityid,
    "Briefcase Id": (g == null ? void 0 : g.briefcaseid) === "" ? "No Briefcase Id" : g == null ? void 0 : g.briefcaseid,
    "Context Id": (g == null ? void 0 : g.contextid) === "" ? "No Context Id" : g == null ? void 0 : g.contextid,
    "Ctx. Name": (i == null ? void 0 : i.contextName) === "" ? "No Context Name" : i == null ? void 0 : i.contextName,
    "Job Def. Id": (i == null ? void 0 : i.jobDefID) === "" ? "No Job Definition Id" : i == null ? void 0 : i.jobDefID,
    "Job Id": (g == null ? void 0 : g.jobid) === "" ? "No Job Id" : g == null ? void 0 : g.jobid,
    "Job Run Id": (i == null ? void 0 : i.jobRunID) === "" ? "No Job Run Id" : i == null ? void 0 : i.jobRunID,
    "iModel Id": (g == null ? void 0 : g.imodelid) === "" ? "No iModel Id" : g == null ? void 0 : g.imodelid,
    "iModel Name": (i == null ? void 0 : i.modelName) === "" ? "No Model Name" : i == null ? void 0 : i.modelName,
    "Org. Name": (i == null ? void 0 : i.organizationName) === "" ? "No Organization Name" : i == null ? void 0 : i.organizationName,
    "User Email": (i == null ? void 0 : i.userEmail) === "" ? "No User Email" : i == null ? void 0 : i.userEmail
  };
  return /* @__PURE__ */ t("div", {
    className: n.className,
    children: /* @__PURE__ */ t(ji, {
      content: /* @__PURE__ */ m(Me, {
        elevation: 1,
        className: "isr-support-debugIDWrapper",
        children: [o["Activity Id"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.activityid}:`
          }), /* @__PURE__ */ t(S, {
            children: o["Activity Id"]
          })]
        }), o["Briefcase Id"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.briefcaseid}:`
          }), /* @__PURE__ */ t(S, {
            children: o["Briefcase Id"]
          })]
        }), o["Context Id"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.contextid}:`
          }), /* @__PURE__ */ t(S, {
            children: o["Context Id"]
          })]
        }), o["Ctx. Name"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.contextName}:`
          }), /* @__PURE__ */ t(S, {
            children: o["Ctx. Name"]
          })]
        }), o["Job Def. Id"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.jobDefID}:`
          }), /* @__PURE__ */ t(S, {
            children: o["Job Def. Id"]
          })]
        }), o["Job Id"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.jobid}:`
          }), /* @__PURE__ */ t(S, {
            children: o["Job Id"]
          })]
        }), o["Job Run Id"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ m(_, {
            as: "span",
            children: ["`$", u.jobRunID, ":`"]
          }), /* @__PURE__ */ t(S, {
            children: o["Job Run Id"]
          })]
        }), o["iModel Id"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.modelid}:`
          }), /* @__PURE__ */ t(S, {
            children: o["iModel Id"]
          })]
        }), o["iModel Name"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.modelName}:`
          }), /* @__PURE__ */ t(S, {
            children: o["iModel Name"]
          })]
        }), o["Org. Name"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.organizationName}:`
          }), /* @__PURE__ */ t(S, {
            children: o["Org. Name"]
          })]
        }), o["User Email"] && /* @__PURE__ */ m("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ t(_, {
            as: "span",
            children: `${u.userEmail}:`
          }), /* @__PURE__ */ t(S, {
            children: o["User Email"]
          })]
        }), n.children]
      }),
      trigger: "click",
      interactive: !0,
      placement: "auto-start",
      children: /* @__PURE__ */ t(ki, {
        className: "isr-support-open",
        styleType: "borderless",
        size: "small",
        children: u.idsForTechSupport
      })
    })
  });
};
const Dn = ({
  children: n,
  className: i,
  ...C
}) => /* @__PURE__ */ t("div", {
  className: W("isr-report-title-wrapper", i),
  ...C,
  children: n
}), wn = {
  Authorization: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  BriefcaseToiModel: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  BusinessProperties: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Compatibility: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  CorruptData: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  DigitalRights: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  DiskIO: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Filtering: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  IModel: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  InconsistentData: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  InputFiles: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  MissingData: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Synchronization: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  ToolkitError: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  UnexpectedData: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Unknown: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Unsupported: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  VisualFidelity: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  }
}, $ = D.createContext(void 0), mn = ({
  data: n,
  workflowMapping: i = wn,
  children: C,
  className: g
}) => {
  const [u, o] = D.useState("problems"), [s, a] = D.useState(), [R, p] = D.useState(["Error", "Warning", "Info"]), [w, I] = D.useState([]);
  return D.useEffect(() => {
    if (!i)
      return;
    const F = Array.from(new Set(Object.values(i).flatMap((N) => Object.values(N).flatMap((y) => y))));
    I([...F, "Unorganized"]);
  }, [i]), /* @__PURE__ */ t(Bi, {
    theme: "inherit",
    children: /* @__PURE__ */ t($.Provider, {
      value: {
        reportData: n,
        workflowMapping: i,
        currentTable: u,
        setCurrentTable: o,
        currentAuditInfo: s,
        setCurrentAuditInfo: a,
        focusedIssues: R,
        setFocusedIssues: p,
        focusedWorkflows: w,
        setFocusedWorkflows: I
      },
      children: /* @__PURE__ */ t("div", {
        className: W("isr-report-main", g),
        children: C != null ? C : /* @__PURE__ */ m(ye, {
          children: [/* @__PURE__ */ m(Dn, {
            children: [/* @__PURE__ */ t(Qi, {}), /* @__PURE__ */ t(vn, {})]
          }), /* @__PURE__ */ m(cn, {
            children: [/* @__PURE__ */ t(en, {}), /* @__PURE__ */ t(sn, {})]
          }), /* @__PURE__ */ m(gn, {
            children: [/* @__PURE__ */ t(_, {
              as: "span",
              children: "Synchronization Issues"
            }), /* @__PURE__ */ t(rn, {})]
          }), /* @__PURE__ */ m(Cn, {
            children: [/* @__PURE__ */ m(an, {
              children: [/* @__PURE__ */ t(ti, {}), /* @__PURE__ */ t(ni, {})]
            }), /* @__PURE__ */ t(Rn, {})]
          })]
        })
      })
    })
  });
};
export {
  ti as FilesTable,
  ni as ProblemsTable,
  mn as Report,
  sn as ReportBanner,
  $ as ReportContext,
  vn as ReportDebugIds,
  cn as ReportHeaderBannerWrapper,
  Rn as ReportInfoPanel,
  Cn as ReportInfoPanelWrapper,
  rn as ReportTableSelect,
  gn as ReportTableSelectWrapper,
  an as ReportTableView,
  en as ReportTimestamp,
  Qi as ReportTitle,
  Dn as ReportTitleWrapper
};
